import { useState, useEffect } from 'react';
import { toast } from 'sonner';
import { devicesApi } from '@/lib/api';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Loader2 } from 'lucide-react';

export const ReplaceAttrappDialog = ({ device, onClose, onDone }) => {
  const [eui, setEui] = useState('');
  const [conn, setConn] = useState('wifi');
  const [saving, setSaving] = useState(false);

  useEffect(() => { setEui(''); setConn(device?.connection_type || 'wifi'); }, [device]);

  const submit = async () => {
    if (!eui.trim()) { toast.error('Ange sensorns ID/EUI'); return; }
    setSaving(true);
    try {
      const res = await devicesApi.link(device.id, { device_eui: eui.trim(), connection_type: conn });
      toast.success(res.data.message || 'Attrappen är ersatt');
      onDone();
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Kunde inte ersätta attrappen');
    } finally { setSaving(false); }
  };

  return (
    <Dialog open={!!device} onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="replace-attrapp-dialog">
        <DialogHeader>
          <DialogTitle>Ersätt med riktig sensor</DialogTitle>
          <DialogDescription>
            {device?.room_name ? `Rum: ${device.room_name}. ` : ''}Rum och namn behålls – attrappen blir en riktig sensor.
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4">
          <div className="space-y-2">
            <Label>Anslutning</Label>
            <Select value={conn} onValueChange={setConn}>
              <SelectTrigger data-testid="replace-attrapp-conn"><SelectValue /></SelectTrigger>
              <SelectContent>
                <SelectItem value="wifi">WiFi</SelectItem>
                <SelectItem value="lorawan">LoRaWAN</SelectItem>
              </SelectContent>
            </Select>
          </div>
          <div className="space-y-2">
            <Label>Sensorns ID / EUI</Label>
            <Input value={eui} onChange={(e) => setEui(e.target.value)} className="font-mono"
              placeholder={conn === 'wifi' ? 'sensor001' : 'A81758FFFE123456'} data-testid="replace-attrapp-eui" />
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose} data-testid="replace-attrapp-cancel">Avbryt</Button>
          <Button onClick={submit} disabled={saving} className="bg-navy hover:bg-navy/90" data-testid="replace-attrapp-submit">
            {saving && <Loader2 className="h-4 w-4 mr-2 animate-spin" />}Ersätt
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
